<script>
// import gsap from 'gsap'

export default {
  props: {
    dVal: {
      type: String,
      default: 'M0,0, L100,100',
    },
    fadeTime: {
      type: Number,
      default: 1000,
    },
  },
  data: () => ({
    customFade: '',
  }),
  mounted() {
    /* gsap.config({ force3D: true })
    gsap.to('.stOn', {
      strokeDashoffset: 100,
      repeat: -1,
      ease: 'none',
      duration: 10,
    }) */
    setTimeout(() => {
      this.customFade = 'fadeIn'
    }, this.fadeTime)
  },
  methods: {
    fadeOut() {
      this.customFade = 'fadeOut'
    },
  },
}
</script>

<template>
  <div :class="['svgContainer', customFade]">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <path
        id="dashed"
        stroke-width="20"
        stroke-linecap="round"
        stroke-dasharray="1, 30"
        class="stOn"
        :d="dVal"
      />
    </svg>
  </div>
</template>

<style lang="scss">
.svgContainer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  transition: opacity 2s;

  &.fadeIn {
    opacity: 0;
  }

  &.fadeOut {
    opacity: 0;
  }
  .stOn {
    clear: both;
    opacity: 0.6;
    fill: none;
    fill-rule: evenodd;
    stroke: #fff;
    stroke-dasharray: 0.8;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 0;
    stroke-width: 0.3;
  }
}
</style>
